export const domain1 = "@x-mail.plus";
export const domain2 = "@pochta.plus";

export const loginClickHandler = (langs) => {
  window.sendLoginForm(langs);
  return false;
};

export const registerClickHandler = () => {
  document.location.href = "/register";
};

export const goLoginClickHandler = () => {
  document.location.href = "/";
};

export const recoverClickHandler = () => {
  window.event.preventDefault();
  document.location.href = "/recover";
};
